import React from 'react';
import { colors } from '../utils/colors';
interface RegionData {
  id: string;
  name: string;
  count: number;
  path: string;
}
interface NZMapProps {
  regionData: RegionData[];
  onRegionHover?: (region: RegionData | null) => void;
  selectedRegion?: string | null;
}
const NZMap: React.FC<NZMapProps> = ({
  regionData,
  onRegionHover,
  selectedRegion
}) => {
  // Function to determine the fill color based on submission count using the new color palette
  const getRegionColor = (count: number) => {
    if (count >= 250) return colors.primary.dark;
    if (count >= 200) return colors.primary.medium;
    if (count >= 150) return colors.primary.light;
    if (count >= 100) return colors.ui.lightTeal;
    return colors.ui.veryLightTeal;
  };
  return <div className="w-full h-full" data-id="element-74">
      <svg viewBox="0 0 800 1000" className="w-full h-full" style={{
      maxHeight: '500px'
    }} data-id="element-75">
        {/* North Island */}
        {regionData.filter(region => ['northland', 'auckland', 'waikato', 'bayofplenty', 'gisborne', 'hawkesbay', 'taranaki', 'manawatu', 'wellington'].includes(region.id)).map(region => <path key={region.id} d={region.path} fill={selectedRegion === region.id ? colors.primary.dark : getRegionColor(region.count)} stroke="#fff" strokeWidth="2" onMouseEnter={() => onRegionHover && onRegionHover(region)} onMouseLeave={() => onRegionHover && onRegionHover(null)} className="transition-colors duration-200 cursor-pointer hover:opacity-80" data-id="element-76" />)}
        {/* South Island */}
        {regionData.filter(region => ['tasman', 'marlborough', 'westcoast', 'canterbury', 'otago', 'southland'].includes(region.id)).map(region => <path key={region.id} d={region.path} fill={selectedRegion === region.id ? colors.primary.dark : getRegionColor(region.count)} stroke="#fff" strokeWidth="2" onMouseEnter={() => onRegionHover && onRegionHover(region)} onMouseLeave={() => onRegionHover && onRegionHover(null)} className="transition-colors duration-200 cursor-pointer hover:opacity-80" data-id="element-77" />)}
      </svg>
    </div>;
};
export default NZMap;